<template>
  <div ref="card" class="dOptions" v-show="show" v-click-outside="closeCard" :style="adjustStyle">
    <!-- <div class="header">
      <div class="avatar">
        <img :src="content.avatar" alt="avatar">
      </div>
      <div class="user">
        <p class="name">{{content.name}}</p>
        <p>xnews</p>
      </div>
    </div>
    <div class="content">
      <div class="line">
        <img src="@assets/img/common/tel.svg" alt="tel">
        <p class="detail">{{content.tel}}</p>
      </div>
      <div class="line">
        <img src="@assets/img/common/mail.svg" alt="mail">
        <p class="detail">{{content.mail}}</p>
      </div>
    </div> -->
    <!-- <div class="dOptions"> -->
      <p v-if="detailData.platform_key != 'new_media_knews'" :class="{'disableD': !detailData.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
        <img src="@assets/img/common/800k.svg" alt="800k">
        <i>800K码流</i>
      </p>
      <p v-if="detailData.has_publish_quality_download_role" :class="{'disableD': !detailData.has_publish_quality_download_role}" @click="downloadSource(img, 2)">
        <img src="@assets/img/common/HD.svg" alt="HD">
        <i>发布码流</i>
      </p>
      <p v-if="img.original_exists" :class="{'disableD': !detailData.has_high_quality_download_role}" @click="downloadSource(img, 1)">
        <img src="@assets/img/common/HD.svg" alt="HD">
        <i>原始码流</i>
      </p>
    <!-- </div> -->
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import vClickOutside from 'v-click-outside'

export default {
  name: 'card',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      show: true,
      defaultAvatar: require('@assets/img/common/defaultAvatar.png'),
      content: {
        avatar: require('@assets/img/common/defaultAvatar.png'),
        name: '',
        tel: '',
        mail: ''
      },
      adjustStyle: {},
      detailData: {},
      img: {},
      query: null,
      subject_type: 0
    }
  },
  methods: {
    downloadSource(source, type) {
      if (type === 0) {
        if (!this.detailData.has_low_quality_download_role) {
          this.$toast('无下载权限')
          return
        } else {
          if (source.content.status != 1) {
            this.$toast('转码尚未完成')
            return
          }
        }
      } else if (type === 1) {
        if(source.type == 3){
          if (!this.detailData.has_high_quality_download_role && !this.detailData.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else{
          if (!this.detailData.has_high_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }
      } else if (type === 2) {
        if (!this.detailData.has_publish_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
      }

      const info = {
        idstring: source.idstring,
        file_quality: type || 0,
        subject_type: this.subject_type,
        subject_id: this.query
      }
      const url = apis.File_download
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys)

      common.exportRes(url, params, 1)
    },
    closeCard() {
      this.content = {
        avatar: this.defaultAvatar,
        name: '',
        tel: '',
        mail: ''
      }

      this.close()
    },
    open(subject_type, query, id1, id, type=0) {
      console.log(id)
      this.show = true
      this.detailData = id1;
      this.img = id;
      this.query = query;
      this.subject_type = subject_type;
      // if (id == 0) return
      
      // this.getUserCard(id, type)
      // .then((r) => {
      //   this.show = true
      //   this.$nextTick(() => {
      //     this.adjustPosition()
      //   })
      // })
    },
    adjustPosition() {
      // 根据视图调整窗口位置,使其能够出现在窗口内
      const cardElementRect = this.$refs.card.getBoundingClientRect()
      const elementBottom = cardElementRect.top + cardElementRect.height
      const elementRight = cardElementRect.left + cardElementRect.width
      const windowHeight = window.innerHeight
      const windowWidth = window.innerWidth
      const gap = 20
      let mright = 0
      let mbottom = 0
      if (elementBottom >= windowHeight - 20) {
        mbottom = elementBottom - windowHeight + gap
      }

      if (elementRight >= windowWidth - 20) {
        mright = elementRight - windowWidth + gap
      }

      const adjustStyle = {
        transform: `translate(-${mright}px, -${mbottom}px)`
      }

      this.adjustStyle = adjustStyle
    },
    getUserCard(id, type) {
      // 获取用户卡片数据
      const info = {
        user_id: id,
        type: type
      }
      const obj = {
        data: info,
        hideLoading: true
      }

      return common.myFetch(apis.Usr_card, obj)
      .then((r) => {
        if (r) {
          const content = {
            avatar: r.avatar || this.defaultAvatar,
            name: r.truename || '无',
            tel: r.phone || '无',
            mail: r.email || '无'
          }

          this.content = content
        }

        return r
      })
    },
    close() {
      this.show = false
    }
  },
  mounted() {
    this.defaultAvatar = this.$_syscfg.default_avatar
    this.content.avatar = this.$_syscfg.default_avatar
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .dOptions {
    position: absolute;
    width: 135px;
    // height: 80px;
    right: 0;
    margin-top: 20px;
    border-radius: 4px;
    overflow: hidden;
    background-color: rgba(5, 15, 15, 0.8);
    p {
      height: 40px;
      // background-color: rgba(5, 15, 15, 0.8);
      display: flex;
      padding: 0 20px;
      cursor: pointer;
      font-size: 13px;
      color: #fff;
      align-items: center;
      i {
        margin-left: 10px;
      }
    }
    .disableD {
      display: none;
      cursor: not-allowed;
      background-color: rgba(255, 255, 255, .1);
    }
  }

</style>
